import { Radio as AntdRadio } from 'antd';
import styled from 'styled-components';

const Radio = styled(AntdRadio)`
  & span.ant-radio-inner::after {
    top: 50%;
    left: 50%;
    width: 11px;
    height: 11px;
    transform: translate(-50%, -50%);
  }
`;

export default Radio;
